// QRCodeScanner.js - VERSION CORRIGÉE
import React, { useState, useEffect } from 'react';
import './QRCodeScanner.css';

function QRCodeScanner() {
  const [scannedPoints, setScannedPoints] = useState(0);
  const [userPoints, setUserPoints] = useState(0);
  const [qrCodeData, setQrCodeData] = useState(null);
  const [scanHistory, setScanHistory] = useState([]);
  const [inputData, setInputData] = useState('');
  const [selectedReward, setSelectedReward] = useState(null);

  // 🔥 CORRECTION: Déplacer la logique d'utilisation des points dans une fonction séparée
  const handleUsePoints = (points, rewardName) => {
    if (userPoints >= points) {
      setUserPoints(prev => prev - points);
      
      // Ajouter à l'historique
      setScanHistory(prev => [{
        date: new Date().toLocaleString(),
        action: 'use',
        points: -points,
        reward: rewardName,
        type: 'redemption'
      }, ...prev.slice(0, 9)]);
      
      alert(`🎉 Récompense obtenue : ${rewardName} (-${points} points)`);
    } else {
      alert(`❌ Points insuffisants : ${userPoints}/${points} points`);
    }
  };

  // Fonction pour scanner
  const handleScan = () => {
    if (!inputData.trim()) {
      alert("Veuillez entrer des données JSON");
      return;
    }

    try {
      const parsedData = JSON.parse(inputData);
      const points = parsedData.totalPoints || 0;
      
      if (points <= 0) {
        alert("❌ Aucun point trouvé dans les données");
        return;
      }
      
      setScannedPoints(points);
      setQrCodeData(parsedData);
      
      // Mettre à jour les points utilisateur
      setUserPoints(prev => {
        const newTotal = prev + points;
        return newTotal;
      });
      
      // Mettre à jour l'historique
      setScanHistory(prev => {
        const newEntry = {
          date: new Date().toLocaleString(),
          action: 'add',
          points: points,
          billNumber: parsedData.billNumber || 'N/A',
          location: parsedData.location || 'Inconnu',
          type: 'scan'
        };
        return [newEntry, ...prev.slice(0, 9)];
      });
      
      alert(`✅ ${points} points ajoutés à votre compte !`);
      setInputData('');
      
    } catch (error) {
      console.error("Erreur parsing JSON:", error);
      alert("❌ Format JSON invalide. Vérifiez la syntaxe.");
    }
  };

  // Récompenses disponibles
  const rewards = [
    { id: 1, points: 100, name: "Soda Gratuit", description: "Boisson au choix" },
    { id: 2, points: 250, name: "Dessert Gratuit", description: "Dessert de la maison" },
    { id: 3, points: 500, name: "Menu Gratuit", description: "Menu complet" },
    { id: 4, points: 1000, name: "Repas Complet", description: "Pour 2 personnes" }
  ];

  // Charger depuis localStorage
  useEffect(() => {
    const savedPoints = localStorage.getItem('spintoss_user_points');
    const savedHistory = localStorage.getItem('spintoss_scan_history');
    
    if (savedPoints) {
      setUserPoints(parseInt(savedPoints, 10));
    }
    
    if (savedHistory) {
      try {
        setScanHistory(JSON.parse(savedHistory));
      } catch (error) {
        console.error("Erreur chargement historique:", error);
      }
    }
  }, []);

  // Sauvegarder dans localStorage
  useEffect(() => {
    localStorage.setItem('spintoss_user_points', userPoints.toString());
    localStorage.setItem('spintoss_scan_history', JSON.stringify(scanHistory));
  }, [userPoints, scanHistory]);

  // Charger exemple
  const loadExample = () => {
    const exampleData = {
      billNumber: `TEST${Math.floor(Math.random() * 1000).toString().padStart(3, '0')}`,
      totalPoints: Math.floor(Math.random() * 50) + 10,
      date: new Date().toISOString(),
      location: "SPINTOSS TM",
      items: [
        { name: "Burger Spécial", quantity: 1, points: 8 },
        { name: "Frites", quantity: 1, points: 4 },
        { name: "Boisson", quantity: 1, points: 3 }
      ]
    };
    setInputData(JSON.stringify(exampleData, null, 2));
  };

  // Réinitialiser les points
  const resetPoints = () => {
    if (window.confirm("Êtes-vous sûr de vouloir réinitialiser tous vos points ?")) {
      setUserPoints(0);
      setScanHistory([]);
      setScannedPoints(0);
      setQrCodeData(null);
      localStorage.removeItem('spintoss_user_points');
      localStorage.removeItem('spintoss_scan_history');
      alert("Points réinitialisés avec succès !");
    }
  };

  // Calculer le prochain objectif
  const getNextGoal = () => {
    const nextReward = rewards.find(reward => reward.points > userPoints);
    return nextReward ? {
      name: nextReward.name,
      needed: nextReward.points - userPoints,
      total: nextReward.points
    } : null;
  };

  const nextGoal = getNextGoal();

  return (
    <div className="qr-scanner">
      {/* En-tête */}
      <div className="scanner-header">
        <h2>📱 Scanner vos Points Cadeaux</h2>
        <div className="points-display">
          <div className="total-points">
            <span className="label">Vos Points</span>
            <span className="value">{userPoints}</span>
          </div>
          {nextGoal && (
            <div className="next-goal">
              <span className="label">Prochain objectif</span>
              <span className="goal-name">{nextGoal.name}</span>
              <span className="goal-points">{userPoints}/{nextGoal.total} pts</span>
            </div>
          )}
        </div>
      </div>

      {/* Section Scanner */}
      <div className="scanner-section">
        <h3>1. Scanner votre QR Code</h3>
        <div className="scanner-interface">
          <div className="scanner-simulator">
            <p>📋 Collez les données du QR Code ici :</p>
            <textarea
              value={inputData}
              onChange={(e) => setInputData(e.target.value)}
              placeholder={`Exemple :\n{\n  "billNumber": "001",\n  "totalPoints": 15,\n  "location": "SPINTOSS JM"\n}`}
              rows="8"
              style={{ fontFamily: 'monospace', fontSize: '13px' }}
            />
            <div className="scanner-buttons">
              <button onClick={handleScan} className="scan-btn">
                🔍 Scanner et Ajouter Points
              </button>
              <button onClick={loadExample} className="example-btn">
                📋 Charger un Exemple
              </button>
            </div>
            
            <div style={{ marginTop: '15px', fontSize: '12px', color: '#666' }}>
              <p><strong>Note :</strong> Les données doivent être au format JSON.</p>
            </div>
          </div>

          {qrCodeData && (
            <div className="scan-result">
              <h4>Dernier scan réussi</h4>
              <div className="scan-details">
                <p><strong>🎫 Ticket :</strong> {qrCodeData.billNumber}</p>
                <p><strong>⭐ Points ajoutés :</strong> {scannedPoints}</p>
                <p><strong>📍 Localisation :</strong> {qrCodeData.location}</p>
                <p><strong>📅 Date :</strong> {new Date(qrCodeData.date).toLocaleDateString()}</p>
                {qrCodeData.items && (
                  <div>
                    <p><strong>🛒 Articles :</strong></p>
                    <ul style={{ marginLeft: '20px', fontSize: '12px' }}>
                      {qrCodeData.items.slice(0, 3).map((item, index) => (
                        <li key={index}>{item.name} x{item.quantity}</li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Section Récompenses */}
      <div className="rewards-section">
        <h3>2. Échanger vos Points</h3>
        <div className="rewards-grid">
          {rewards.map(reward => (
            <div key={reward.id} className="reward-card">
              <div className="reward-header">
                <h4>{reward.name}</h4>
                <span className="required-points">{reward.points} pts</span>
              </div>
              <p className="reward-description">{reward.description}</p>
              <div className="reward-progress">
                <div className="progress-bar">
                  <div 
                    className="progress-fill"
                    style={{ 
                      width: `${Math.min(100, (userPoints / reward.points) * 100)}%` 
                    }}
                  ></div>
                </div>
                <span className="progress-text">
                  {Math.min(userPoints, reward.points)}/{reward.points} pts
                </span>
              </div>
              <button
                onClick={() => handleUsePoints(reward.points, reward.name)}
                disabled={userPoints < reward.points}
                className={`reward-btn ${userPoints >= reward.points ? 'available' : 'unavailable'}`}
              >
                {userPoints >= reward.points ? '✅ Échanger' : `🔒 ${reward.points - userPoints} pts manquants`}
              </button>
            </div>
          ))}
        </div>
      </div>

      {/* Section Historique */}
      <div className="history-section">
        <h3>3. Historique des Transactions</h3>
        {scanHistory.length > 0 ? (
          <div className="history-list">
            {scanHistory.map((scan, index) => (
              <div key={index} className={`history-item ${scan.type}`}>
                <div className="history-date">{scan.date}</div>
                <div className="history-details">
                  <div className="history-action">
                    {scan.type === 'scan' ? '📥 Ajout' : '📤 Utilisation'}
                  </div>
                  <div className="history-info">
                    {scan.billNumber && <span>Ticket {scan.billNumber}</span>}
                    {scan.reward && <span className="reward-name">{scan.reward}</span>}
                  </div>
                </div>
                <div className={`history-points ${scan.points > 0 ? 'positive' : 'negative'}`}>
                  {scan.points > 0 ? `+${scan.points}` : scan.points} pts
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="no-history">Aucune transaction enregistrée</p>
        )}
      </div>

      {/* Section Instructions */}
      <div className="instructions-section">
        <h3>💡 Comment ça marche ?</h3>
        <div className="instructions">
          <div className="instruction-step">
            <div className="step-number">1</div>
            <div className="step-content">
              <strong>Achetez chez SPINTOSS</strong>
              <p>Chaque produit vous donne des points cadeaux</p>
            </div>
          </div>
          <div className="instruction-step">
            <div className="step-number">2</div>
            <div className="step-content">
              <strong>Scannez votre ticket</strong>
              <p>Collez les données du QR Code pour ajouter vos points</p>
            </div>
          </div>
          <div className="instruction-step">
            <div className="step-number">3</div>
            <div className="step-content">
              <strong>Échangez vos points</strong>
              <p>Utilisez vos points pour obtenir des récompenses</p>
            </div>
          </div>
        </div>
      </div>

      {/* Actions supplémentaires */}
      <div className="extra-actions">
        <button onClick={resetPoints} className="reset-btn">
          🔄 Réinitialiser mes Points
        </button>
        <div className="stats-info">
          <p><strong>Statistiques :</strong></p>
          <ul>
            <li>Total des points scannés : {scanHistory.filter(h => h.type === 'scan').reduce((sum, h) => sum + h.points, 0)}</li>
            <li>Total des points utilisés : {Math.abs(scanHistory.filter(h => h.type === 'redemption').reduce((sum, h) => sum + h.points, 0))}</li>
            <li>Nombre de scans : {scanHistory.filter(h => h.type === 'scan').length}</li>
            <li>Récompenses obtenues : {scanHistory.filter(h => h.type === 'redemption').length}</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default QRCodeScanner;